import React from "react";

export const ModalAviso = ({ handleClose, children }) => {
    return (
        <>
            <div className="modalAvisoBackdrop" onClick={handleClose}></div>
            <div className="modalAvisoScreenContainer">
                <div className="modalAvisoScreen">
                    <div className="closeButton ">
                        <span onClick={handleClose}>X</span>
                    </div>
                    <p className="title">Aviso de vencimiento</p>

                    <div className="content">{children}</div>
                    {/* <button className="btn-modalForm" onClick={handleClose}>CERRAR</button> */}
                </div>
            </div>
        </>
    );
};
